export default __webpack_public_path__ + "static/media/Office_Work.a15d72ec.svg";